export default __webpack_public_path__ + "static/media/rabbit.e9989a2b.png";